import { render, staticRenderFns } from "./VisaExpiredCountryWise.vue?vue&type=template&id=2d88fb11&"
import script from "./VisaExpiredCountryWise.vue?vue&type=script&lang=js&"
export * from "./VisaExpiredCountryWise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports